import { useState, useRef, useEffect } from "react";
import { MdKeyboardArrowDown } from "react-icons/md";
import { useAppDispatch, useAppSelector } from "@/common/hooks";
import { Iapp } from "@/module/applications/types";
import routes from "@/common/routes";
import { appStateActions } from "@/store/helperReducers/appStateSlice";
import { appActions } from "@/module/applications/store/slice";
import { useLocation, useNavigate } from "react-router-dom";

function ApplicationsDropdown() {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);
  const { data: apps } = useAppSelector((state) => state.app.allApps);
  const { openedTabs } = useAppSelector((state) => state.appState);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const currentApp = openedTabs.find(
    (app) => app.primary && location.pathname.includes(app.primary),
  );

  // close on outside click
  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const clickHandler = (row: Iapp) => {
    const path = routes.protected.applications.app.wallet.link(row?._id);
    if (!openedTabs.find((tab) => tab.id === row._id)) {
      const primary = routes.protected.applications.app.link(row?._id);
      dispatch(
        appStateActions.addNewTab({
          id: row._id,
          name: row.name,
          link: path,
          title: row.name,
          primary,
          icon: row.logo_url,
        }),
      );
      dispatch(appActions.addTabApplication({ appid: row._id }));
    }
    navigate(path);

    setOpen(false);
  };

  if (!currentApp) return null;

  return (
    <div ref={ref} className="relative inline-block row-start-1 row-end-2">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex w-max items-center gap-x-5 rounded-xl border border-gray-320/30 py-1.5 px-4 font-bold text-teal-40 cursor-pointer"
      >
        {currentApp.icon && (
          <span>
            <img src={currentApp.icon} alt="Logo" className="h-8 w-8" />
          </span>
        )}
        <span>{currentApp.name}</span>
        <span>
          <MdKeyboardArrowDown />
        </span>
      </button>

      {open && (
        <div className="absolute z-10 mt-1 w-full rounded-md border border-gray-200 bg-white shadow-lg h-[25rem] overflow-y-auto">
          {apps.map((app) => (
            <button
              key={app._id}
              type="button"
              onClick={() => clickHandler(app)}
              className={`w-full px-3 py-2 text-left text-sm text-gray-700 hover:bg-slate-100 flex items-center gap-x-2
              `}
            >
              <span>
                <img src={app.logo_url} alt="Logo" className="h-10 w-10" />
              </span>
              <span>{app.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default ApplicationsDropdown;
